export const SHOW_MODAL_EXAMPLE = "SHOW_MODAL_EXAMPLE"
export const LOAD_REVIEWS = "LOAD_REVIEWS"